import type { FC } from 'react';
import { InitializerBlockWrapper } from './InitializerBlock.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Alert } from 'reactstrap';

interface InitializerBlockProps {}

const InitializerBlock: FC<InitializerBlockProps> = () => (
 <InitializerBlockWrapper>
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Initializer Block</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <ul className="text-align-justify">
         <li>If a class contains some code just within curly braces{ }, it is known as the initializer block. </li>
         <li>As soon as the object of a class is created, all constructors’ initializer block will get executed in sequence. </li>
         <li>It is useful when the same code is to be written in all constructors.</li>
         <li>Only one constructor will get executed so that the value will be assigned in all constructors. In contrast, all initializer blocks are executed so that the value will be assigned in only one initializer block.</li>
         <li>The initializer block gets executed before the constructor.</li>
         <li>It is not at all mandatory to include them in your classes.</li>
      </ul>

      <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
      {
         'public class Calculate {\n'+
         '  //Initializer block starts\n'+
         '  {\n'+
         '    System.out.println("Initializer block executed!!");\n'+
         '  }\n'+
         '  //Initializer block ends\n'+
         '\n'+
         '  public Calculate() {\n'+
         '    System.out.println("Constructor executed!!");\n'+
         '  }\n'+
         '  public static void main(String args[]) {\n'+
         '    Calculate caliculate = new Calculate();\n'+
         '  }\n'+
         '}'
      }
      </SyntaxHighlighter>
      <Alert className="text-align-justify" color="secondary">
         <strong>OUTPUT:</strong><br/>
         Initializer block executed!!<br/>
         Constructor executed!!
      </Alert>

      <Alert className="text-align-center">
         <a href="/oops-concepts">To know more about OOPS, click here..</a>
      </Alert>
   </div>
 </InitializerBlockWrapper>
);

export default InitializerBlock;
